module.exports = __webpack_public_path__ + "static/media/shape.e50d81b0.svg";